(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agent-access-info', {
                parent: 'entity',
                url: '/agent-access-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentAccessInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-access-info/agent-access-infos.html',
                        controller: 'AgentAccessInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentAccessInfo');
                        $translatePartialLoader.addPart('agentAccessType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agent-access-info-detail', {
                parent: 'entity',
                url: '/agent-access-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentAccessInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-access-info/agent-access-info-detail.html',
                        controller: 'AgentAccessInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentAccessInfo');
                        $translatePartialLoader.addPart('agentAccessType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgentAccessInfo', function ($stateParams, AgentAccessInfo) {
                        return AgentAccessInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agent-access-info.new', {
                parent: 'agent-access-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-access-info/agent-access-info-dialog.html',
                        controller: 'AgentAccessInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    accessType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agent-access-info', null, {reload: true});
                    }, function () {
                        $state.go('agent-access-info');
                    });
                }]
            })
            .state('agent-access-info.edit', {
                parent: 'agent-access-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-access-info/agent-access-info-dialog.html',
                        controller: 'AgentAccessInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgentAccessInfo', function (AgentAccessInfo) {
                                return AgentAccessInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-access-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agent-access-info.delete', {
                parent: 'agent-access-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-access-info/agent-access-info-delete-dialog.html',
                        controller: 'AgentAccessInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgentAccessInfo', function (AgentAccessInfo) {
                                return AgentAccessInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-access-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
